import { AuthenticationData } from '../store/authentication';
import { SelectedConsolidations } from '../types/ConsolidationTypes';
import { apiClient } from './apiClient';

export const getSelectedConsolidations = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string,
    authenticationData?: AuthenticationData,
): Promise<SelectedConsolidations> => {
    return apiClient<SelectedConsolidations>(`${proxyBaseUrl}/consolidation/${arn}`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_selected_consolidations',
        sentryExtra: { arn },
    });
};
